export enum FeatureAddOn {
    ViewerComments = 100,
    ExcelExportImport = 110,
    StorymapCollections = 120,
    PrivateLinkSharing = 130,
    CustomWorkflow = 200,

    TrelloIntegration = 410,
    PivotalTrackerIntegration = 420,
    JiraCloudIntegration = 430,
    JiraOnPremiseIntegration = 440,
    JiraIntegrationImpersonation = 441,
    GitHubIntegration = 450,
    GitHubEnterpriseIntegration = 460,
    TeamFoundationServerIntegration = 470,
    TeamFoundationServerIntegrationImpersonation = 471,
    VisualStudioTeamServicesIntegration = 480,
    VisualStudioTeamServicesIntegrationImpersonation = 481,

    // Visual Studio Team Service
    // Team Foundation Server

    SlackIntegration = 810,
    HipChatIntegration = 820,
    FlowDockIntegration = 830,

    AdvancedWorkspaceSecurity = 900,

    AdvancedRoadmaps = 1000,

    UserStoryTemplates = 1100,

    GlobalPersonas = 1200,

    BasicRoadmaps = 1300,
    StandardRoadmaps = 1400,
    BasicFeedbackManagement = 1500,
    StandardFeedbackManagement = 1600,
    AdvancedFeedbackManagement = 1700,

    AI = 2600,
    CardKeys = 2700,
    ClassicStorymap = 2800,

    DescriptionVersioning = 2901,

    McpAccess = 3000,
}

class SubscriptionManager {
    features: string;
    hasToolIntegrationFeatureAddOn: boolean;

    constructor(useFeatures: string | null | undefined, userHasToolIntegrationFeatureAddOn: boolean | null | undefined) {
        this.features = useFeatures || '';
        this.hasToolIntegrationFeatureAddOn = !!userHasToolIntegrationFeatureAddOn;
    }

    public hasFeatureAddOn(featureAddOn: FeatureAddOn): boolean {
        const addOn = featureAddOn.toString();

        const addons = this.features.split(';');

        return addons.includes(addOn);
    }

    public hasIntegrationFeatureAddOn(): boolean {
        return this.hasToolIntegrationFeatureAddOn;
    }

    public hasJiraImpersonationFeatureAddOn(): boolean {
        return this.hasFeatureAddOn(FeatureAddOn.JiraIntegrationImpersonation);
    }

    public hasTfsImpersonationFeatureAddOn(): boolean {
        return this.hasFeatureAddOn(FeatureAddOn.TeamFoundationServerIntegrationImpersonation);
    }

    public hasVstsImpersonationFeatureAddOn(): boolean {
        return this.hasFeatureAddOn(FeatureAddOn.VisualStudioTeamServicesIntegrationImpersonation);
    }

    public hasAdvancedWorkspaceSecurityFeatureAddOn(): boolean {
        return this.hasFeatureAddOn(FeatureAddOn.AdvancedWorkspaceSecurity);
    }

    public hasTeamChatIntegrationFeatureAddOn(): boolean {
        return (
            this.hasFeatureAddOn(FeatureAddOn.SlackIntegration) ||
            this.hasFeatureAddOn(FeatureAddOn.HipChatIntegration) ||
            this.hasFeatureAddOn(FeatureAddOn.FlowDockIntegration)
        );
    }
}

export const subscriptionManager = new SubscriptionManager(
    initAppData.currentWs?.features,
    initAppData.currentWs?.hasToolIntegrationFeatureAddOn
);
